import React, { Component } from 'react';
import { Popup } from 'react-chat-elements';
import { inject, observer } from 'mobx-react';

import K from "../../../../constants";

import PrivacyAgreements from '../PrivacyAgreements/PrivacyAgreements';

import leonardoStore from "../../../../stores/leonardoStore";

@inject('translationsStore', 'productsStore')
@observer
export default class PrivacyFormPopup extends Component {

    constructor(props) {
        super(props);
    };

    render () {
        const {
            show,
            onClose,
            onAccept,
            translationsStore
        } = this.props;

        const {
            checkedAgreedGeneralConditions,
            checkedAgreedRestrictiveClauses,
            air_club_profiling,
            air_club_marketing,
            air_club_third_parties,
            privacyEnabled
        } = leonardoStore;


        const validAgreements =
            checkedAgreedGeneralConditions &&
            checkedAgreedRestrictiveClauses &&
            air_club_profiling !== null &&
            air_club_marketing !== null &&
            air_club_third_parties !== null;

        const disabledConfirm = !validAgreements || !privacyEnabled;

        return (
            <Popup
                show={show}
                header=" "
                text={
                    <PrivacyAgreements
                        isAssistance={leonardoStore.isAssistance}
                        isMyApp={leonardoStore.isMyAppAddon}
                        checkedAgreedGeneralConditions={checkedAgreedGeneralConditions}
                        checkedAgreedRestrictiveClauses={checkedAgreedRestrictiveClauses}
                        onChangeAgreedGeneralConditions={
                            checked => {leonardoStore.checkedAgreedGeneralConditions = checked }
                        }
                        onChangeAgreedRestrictiveClauses={
                            checked => {leonardoStore.checkedAgreedRestrictiveClauses = checked }
                        }
                        hideSubTitle={true}
                        generalConditionsDocumentSource={K.POLICY_BASE_URL.concat('AIR+-+Condizioni+generali+Servizi+aggiuntivi.pdf')}
                        labelRestrictiveConditions={translationsStore.translate('installerView.sectionAgreements.labelRestrictiveClausesAdditionalProduct')}
                        labelGeneralConditionPrefix={translationsStore.translate('installerView.sectionAgreements.labelAdditionalGeneralConditionsPrefix')}
                        labelGeneralConditionClickable={translationsStore.translate('installerView.sectionAgreements.labelGeneralConditions')}
                        labelGeneralConditionSuffix={translationsStore.translate('installerView.sectionAgreements.labelAdditionalGeneralConditionsSuffix')}
                        { ... (leonardoStore.remoteUserIsFromMoVeInProgram
                        ? {
                            addOnServiceAgreements: {
                                air_club_profiling,
                                air_club_marketing,
                                air_club_third_parties,
                            },
                            onAddOnServiceAgreementsChange: (addOnServiceAgreements) => {
                                leonardoStore.air_club_profiling = addOnServiceAgreements.air_club_profiling;
                                leonardoStore.air_club_marketing = addOnServiceAgreements.air_club_marketing;
                                leonardoStore.air_club_third_parties = addOnServiceAgreements.air_club_third_parties;
                            },
                        }
                        : {})}
                    />
                }
                headerButtons={[
                    {
                    type: 'close',
                    backgroundColor: 'white',
                    color: 'var(--chatbot-primary-color)',
                    text: 'X',
                    onClick: onClose,
                    },
                ]}
                footerButtons={[
                    {
                        color: "white",
                        backgroundColor: null,
                        text: !privacyEnabled? "Condizioni già accettate" : "Accetto le condizioni",
                        onClick: onAccept,
                        className: "privacyAcceptButton",
                        disabled: disabledConfirm,
                    }
                ]}
            />
        );
    }
};
